import React, { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { FileText, Download } from "lucide-react";

export default function Documenten() {
  const [docs, setDocs] = useState([]);
  useEffect(() => { api.get("/documenten").then(r => setDocs(r.data)); }, []);

  return (
    <div data-testid="documenten-page">
      <div className="text-xs uppercase tracking-[0.22em] text-orange-600 font-semibold">Reglementen</div>
      <h1 className="heading-display text-4xl sm:text-5xl mt-1">Download Reglementen</h1>
      <p className="text-slate-600 mt-3 mb-8">Alle officiële reglementen om door te lezen of mee te nemen naar een wedstrijd. Klik op een document om te downloaden.</p>

      <div className="grid sm:grid-cols-2 gap-3" data-testid="docs-list">
        {docs.map((d) => (
          <a
            key={d.filename}
            href={`${API}/documenten/${encodeURIComponent(d.filename)}`}
            target="_blank"
            rel="noreferrer"
            className="gs-card p-4 flex items-start gap-3 hover:border-orange-400 hover:-translate-y-0.5 transition"
            data-testid={`doc-${d.filename}`}
          >
            <div className="w-10 h-10 rounded-lg bg-orange-100 flex items-center justify-center flex-shrink-0">
              <FileText className="text-orange-600" size={20}/>
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold">{d.label}</div>
              <div className="text-xs text-slate-500 mt-1 truncate">{d.filename} · {(d.size/1024).toFixed(0)} KB</div>
            </div>
            <Download size={18} className="text-slate-400"/>
          </a>
        ))}
      </div>
    </div>
  );
}
